const axios = require("axios")
const logger = require("@/utils/logger");
const auth = require("./auth")
const utils = require("./utils")

const config = require("config");
const BASE_URL = config.restAPIURL;

export {
  generateToken,
  list,
  remove
}

function list() {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/admin/tokens`;

  return axios
    .get(url, {
      headers: auth.getHeaders()
    })
    .then(response => {
      return response.data.data;
    })
    .catch(utils.axiosErrorHandler)
}

function generateToken(name, expiration) {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/admin/tokens`;

  return axios
    .post(url, {
      namespace: name,
      expiration: expiration
    }, {
      headers: auth.getHeaders()
    }).then((res) => {
      return res.data.data.token
    })
}

function remove(id) {
  auth.requireAuthRedirect();
  const url = `${BASE_URL}/admin/tokens/` + encodeURIComponent(id);
  return axios
    .delete(url, {
      headers: auth.getHeaders()
    })
}



// WEBPACK FOOTER //
// ./src/utils/token-api.js